import React, { PureComponent } from 'react'
import { translate } from 'react-polyglot'
import axios from 'axios'
import classNames from 'classnames'
import prettyBytes from 'pretty-bytes'
import moment from 'moment'

import { Icon } from 'components'

import DocumentSvg from 'assets/img/svg/document.js'
import ImageSvg from 'assets/img/svg/image.js'
import PdfSvg from 'assets/img/svg/pdf.js'

import './file.scss'

class File extends PureComponent {
	state = {
		progress: null,
	}

	config = {
		onUploadProgress: progressEvent => {
			const progress = Math.round(
				(progressEvent.loaded * 100) / progressEvent.total
			)

			this.setState({ progress })
		},
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	}

	componentDidMount() {
		const {
			node: { data },
		} = this.props
		const formData = data.get('formData')

		if (formData || (formData && formData.size !== 0)) {
			this.onUpload(formData)
		}
	}

	onUpload = formData => {
		axios
			.post('files', formData, this.config)
			.then(response => {
				const {
					editor,
					node,
					node: { data },
				} = this.props

				const name = data.get('name')
				const type = data.get('type')
				const size = data.get('size')
				const lastModified = data.get('lastModified')

				editor.setNodeByKey(node.key, {
					type: 'file',
					data: {
						id: response.data.id,
						name,
						type,
						size,
						lastModified,
					},
				})
			})
			.catch(error => console.log(error))
	}

	onDownload = (id, name) => {
		axios({
			url: `files/${id}`,
			method: 'GET',
			responseType: 'blob',
		})
			.then(response => {
				const url = window.URL.createObjectURL(
					new Blob([response.data])
				)
				const link = document.createElement('a')

				link.href = url
				link.setAttribute('download', name)
				link.click()

				window.URL.revokeObjectURL(url)
			})
			.catch(error => console.log(error))
	}

	renderFileIcon = () => {
		const {
			node: { data },
		} = this.props

		const type = data.get('type') || null

		if (type) {
			switch (true) {
				case type.includes('pdf'):
					return <PdfSvg />
				case type.includes('jpg'):
					return <ImageSvg />
				case type.includes('jpeg'):
					return <ImageSvg />
				case type.includes('png'):
					return <ImageSvg />
				case type.includes('gif'):
					return <ImageSvg />
				case type.includes('svg'):
					return <ImageSvg />
				default:
					return <DocumentSvg />
			}
		}
	}

	render() {
		const { progress } = this.state
		const {
			attributes,
			node: { data },
			t,
		} = this.props

		const isUploading = !data.get('id')
		const percentage = `${100 - parseInt(progress, 10)}%`

		const id = data.get('id') || null
		const name = data.get('name')
		const size = data.get('size') ? prettyBytes(data.get('size')) : null
		const lastModified = moment(data.get('lastModified')).format(
			t('date_format')
		)

		return (
			<div
				{...attributes}
				className={classNames('c-file', attributes.className, {
					'is-uploading': isUploading,
				})}
			>
				<div
					className="c-file__uploading"
					style={{ backgroundPosition: percentage }}
				>
					{progress === 100 ? (
						<span>
							<span className="c-file__spinner" />
							<span>{t('editor.encrypt_file')}</span>
						</span>
					) : (
						<span>{progress || 0} %</span>
					)}
				</div>

				<div className="c-file__item">
					<button
						className="c-file__button"
						onClick={() => this.onDownload(id, name)}
						type="button"
					>
						<div className="c-file__icon">
							{this.renderFileIcon()}
						</div>
						<div className="c-file__meta">
							{name}
							<br />
							<small>{lastModified}</small>
							<small>{size}</small>
						</div>
						<div className="c-file__download">
							<Icon name="download" />
						</div>
					</button>
				</div>
			</div>
		)
	}
}

export default translate()(File)
